import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useBreakpoints from 'hooks/useBreakpoints';
import useCoachDeepLink from 'hooks/useCoachDeepLink';
import { useFetchUserAnalysisSkills, useFetchUserSkillAnalysis } from 'actions/users';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import { getHelixUIMode, getHelixGraphTooltip, isHelixAndLearningHub } from 'utils/helix';
import EmptyStateController from 'components/EmptyStateController';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import GraphCard from 'components/GraphCard';
import Heading from 'components/Heading';
import UserGeneratedText from 'components/UserGeneratedText';
import Flex, { Box } from 'components/Flex';
import SkillPageWrapper from '../components/SkillPageWrapper';
import QuoteSection from '../components/QuoteSection';
import MeetingSection from '../components/MeetingSection';
import SkillContentSection from '../components/SkillContentSection';
import HeadingWithFilter from '../components/HeadingWithFilter';
import ButtonRow from '../components/ButtonRow';
import { SummaryFlagCard } from '..';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SkillAnalysisPage(_ref) {
  var _skillGraphData$skill, _skillGraphData$skill2, _skillGraphData$skill3, _skillGraphData$dates, _skillGraphData$dates2, _skill$skillUsage, _skill$skillUsage2, _skill$userMeetings$l, _skill$userMeetings;
  var isCurrentUser = _ref.isCurrentUser,
    weeksLoading = _ref.weeksLoading,
    weeksError = _ref.weeksError,
    userId = _ref.userId,
    user = _ref.user,
    weekCommencing = _ref.weekCommencing,
    _ref$weeks = _ref.weeks,
    weeks = _ref$weeks === void 0 ? [] : _ref$weeks,
    getUserSkillLocation = _ref.getUserSkillLocation,
    setWeekCommencing = _ref.setWeekCommencing;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useCoachDeepLink();
  var _getHelixUIMode = getHelixUIMode(),
    helixUIMode = _getHelixUIMode.helixUIMode,
    showFeedback = _getHelixUIMode.showFeedback,
    showScores = _getHelixUIMode.showScores;
  var hasOnlyScore = helixUIMode === 'onlyScores';
  var _useParams = useParams(),
    skillIdParam = _useParams.skillId;
  var hasSkillId = Boolean(skillIdParam);
  var skillId = skillIdParam !== null && skillIdParam !== void 0 ? skillIdParam : '';
  var selected = weekCommencing || weeks[0];
  var _useFetchUserSkillAna = useFetchUserSkillAnalysis({
      userId: userId,
      skillId: skillId,
      weekCommencingDate: weekCommencing
    }),
    skill = _useFetchUserSkillAna.data,
    skillsLoading = _useFetchUserSkillAna.isLoading,
    skillsError = _useFetchUserSkillAna.isError;
  var _useFetchUserAnalysis = useFetchUserAnalysisSkills({
      userId: userId,
      skillId: skillId,
      weekCommencingDate: selected,
      enabled: showScores && hasSkillId
    }),
    skillGraphData = _useFetchUserAnalysis.data,
    skillGraphDataLoading = _useFetchUserAnalysis.isLoading,
    skillGraphDataError = _useFetchUserAnalysis.isError;
  var skillName = (skill === null || skill === void 0 ? void 0 : skill.name) || (skillGraphData === null || skillGraphData === void 0 || (_skillGraphData$skill = skillGraphData.skills) === null || _skillGraphData$skill === void 0 || (_skillGraphData$skill = _skillGraphData$skill[0]) === null || _skillGraphData$skill === void 0 ? void 0 : _skillGraphData$skill.name);
  var isLoading = weeksLoading || skillsLoading || skillGraphDataLoading;
  var isError = weeksError || skillsError || skillGraphDataError;
  var _ref2 = (_skillGraphData$skill2 = skillGraphData === null || skillGraphData === void 0 || (_skillGraphData$skill3 = skillGraphData.skills) === null || _skillGraphData$skill3 === void 0 ? void 0 : _skillGraphData$skill3[0]) !== null && _skillGraphData$skill2 !== void 0 ? _skillGraphData$skill2 : {},
    scoreEachWeek = _ref2.scoreEachWeek;
  var graphScores = Array.isArray(scoreEachWeek) ? scoreEachWeek.filter(Number.isFinite) : [];
  var hasGraphScores = graphScores.length >= 1;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  var hasData = scoreEachWeek && (scoreEachWeek === null || scoreEachWeek === void 0 ? void 0 : scoreEachWeek.filter(function (score) {
    return score !== null;
  }).length) > 0;
  var chartLabels = (skillGraphData === null || skillGraphData === void 0 || (_skillGraphData$dates = skillGraphData.dates) === null || _skillGraphData$dates === void 0 ? void 0 : _skillGraphData$dates.map(function (day) {
    return getLocalisedDate({
      date: day,
      options: {
        month: 'short',
        day: 'numeric'
      }
    }) || '';
  })) || [];
  var chartLabelClicks = (skillGraphData === null || skillGraphData === void 0 || (_skillGraphData$dates2 = skillGraphData.dates) === null || _skillGraphData$dates2 === void 0 ? void 0 : _skillGraphData$dates2.map(function (day) {
    return function () {
      return setWeekCommencing(day);
    };
  })) || [];
  var formattedSelected = getLocalisedDate({
    date: selected,
    options: {
      month: 'short',
      day: 'numeric'
    }
  });
  var chartOptions = {
    axisY: {
      showLabel: hasData,
      labelInterpolationFnc: function labelInterpolationFnc(value) {
        return "".concat(Math.round(value), "%");
      },
      showGrid: false,
      low: 0,
      high: 100,
      onlyInteger: true
    }
  };
  var positiveSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage = skill.skillUsage) === null || _skill$skillUsage === void 0 ? void 0 : _skill$skillUsage.positive) || [];
  var negativeSkillUsage = (skill === null || skill === void 0 || (_skill$skillUsage2 = skill.skillUsage) === null || _skill$skillUsage2 === void 0 ? void 0 : _skill$skillUsage2.negative) || [];
  var showButtonRow = isCurrentUser;
  return /*#__PURE__*/_jsxs(SkillPageWrapper, {
    fallbackLink: getUserSkillLocation({}),
    user: user,
    children: [/*#__PURE__*/_jsx(HeadingWithFilter, {
      showScore: hasOnlyScore,
      score: skill === null || skill === void 0 ? void 0 : skill.score,
      weeks: weeks,
      selected: selected,
      setWeekCommencing: setWeekCommencing,
      title: skillName,
      tooltipContent: skill === null || skill === void 0 ? void 0 : skill.description
    }), /*#__PURE__*/_jsx(EmptyStateController, {
      isLoading: isLoading,
      isError: isError,
      isEmpty: !skill && !skillGraphData,
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "l",
        mt: "m",
        children: [hasGraphScores && /*#__PURE__*/_jsx("section", {
          "aria-labelledby": "graph-heading",
          children: /*#__PURE__*/_jsx(GraphCard, {
            title: t('property_weekly_progression'),
            chartLabels: chartLabels,
            chartLabelClicks: chartLabelClicks,
            chartData: scoreEachWeek,
            selectedValue: formattedSelected,
            chartHeight: 200,
            options: chartOptions,
            showScore: false,
            getTooltipReadout: getHelixGraphTooltip,
            showAllLabels: isDesktop
          })
        }), showFeedback && /*#__PURE__*/_jsx("section", {
          "aria-labelledby": "skill-overview-heading",
          children: skill !== null && skill !== void 0 && skill.summary ? /*#__PURE__*/_jsx(SummaryFlagCard, {
            titleId: "skill-overview-heading",
            summary: skill.summary,
            score: skill.score,
            screenContext: _objectSpread({
              description: "AI-generated summary of this skill's performance this week",
              id: skillId
            }, userId && {
              state: {
                userId: userId
              }
            }),
            children: /*#__PURE__*/_jsxs(Stack, {
              spacing: "s",
              children: [(skill === null || skill === void 0 ? void 0 : skill.suggestion) && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Heading, {
                  as: "h4",
                  mb: "xs",
                  mt: "s",
                  size: "small",
                  children: t('property_suggestions')
                }), /*#__PURE__*/_jsx(UserGeneratedText, {
                  text: skill.suggestion
                })]
              }), (positiveSkillUsage.length > 0 || negativeSkillUsage.length > 0) && /*#__PURE__*/_jsx(Box, {
                mt: skill !== null && skill !== void 0 && skill.suggestion ? undefined : 's',
                children: /*#__PURE__*/_jsx(QuoteSection, {
                  skillId: skill.skillId,
                  positiveSkillUsage: positiveSkillUsage,
                  negativeSkillUsage: negativeSkillUsage,
                  getLocation: getUserSkillLocation
                })
              }), showButtonRow && /*#__PURE__*/_jsx(ButtonRow, {
                isCurrentUser: isCurrentUser,
                showContentButtons: false,
                skillName: skill.name,
                summary: skill.summary,
                suggestion: skill.suggestion
              })]
            })
          }) : /*#__PURE__*/_jsx(Landmark, {
            height: 100,
            icon: "asset-fluidbook",
            children: /*#__PURE__*/_jsxs(Flex, {
              gap: "s",
              flexDirection: "column",
              alignItems: "center",
              children: [/*#__PURE__*/_jsx(Text, {
                dimmed: true,
                children: t('skills_empty_state_skill_not_recorded_this_week')
              }), showButtonRow && (skill === null || skill === void 0 ? void 0 : skill.name) && /*#__PURE__*/_jsx(ButtonRow, {
                isCurrentUser: isCurrentUser,
                skillName: skill.name,
                showContentButtons: false
              })]
            })
          })
        }), ((_skill$userMeetings$l = skill === null || skill === void 0 || (_skill$userMeetings = skill.userMeetings) === null || _skill$userMeetings === void 0 ? void 0 : _skill$userMeetings.length) !== null && _skill$userMeetings$l !== void 0 ? _skill$userMeetings$l : 0) > 0 && /*#__PURE__*/_jsx(MeetingSection, {
          userMeetings: skill === null || skill === void 0 ? void 0 : skill.userMeetings,
          getLocation: getUserSkillLocation,
          userId: userId
        }), (skill === null || skill === void 0 ? void 0 : skill.name) && isHelixAndLearningHub && /*#__PURE__*/_jsx(SkillContentSection, {
          isCurrentUser: isCurrentUser,
          userId: userId,
          skillId: skill === null || skill === void 0 ? void 0 : skill.skillId,
          name: skill === null || skill === void 0 ? void 0 : skill.name
        })]
      })
    })]
  });
}
export default SkillAnalysisPage;